import { Modal } from "antd";
import { useAppDispatch, useComponentDidMount } from "core/utils";
import type { FC } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { getAssignedDataGroup, getUserNameFromToken } from "../../../core/router/auth";
import { useLogoutMutation } from "../../../core/router/auth/serverApi";
import { closeChangeDataGroup, openChangeDataGroup } from "../../../core/setup/redux/state/dataGroupModal/dataGroupModalState";
import type { NoneOwnProps } from "../../../core/types";
import { PrimaryButton, SecondaryButton } from "../../Buttons/components/ActionButton";

export const NoDataGroupModal: FC<NoneOwnProps> = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [logout] = useLogoutMutation();

    const [isNoDataGroupModalVisible, setIsNoDataGroupModalVisible] = useState(false);

    const handleAssignExisting = () => {
        dispatch(openChangeDataGroup());
        setIsNoDataGroupModalVisible(false);
    };

    const handleClose = () => {
        setIsNoDataGroupModalVisible(false);
    };

    useComponentDidMount(() => {
        if (getAssignedDataGroup() !== null) {
            dispatch(closeChangeDataGroup());
        } else {
            setIsNoDataGroupModalVisible(true);
        }
    });

    const user = {
        name: getUserNameFromToken(),
    };

    return (
        <Modal
            title={t("modal.title.noDataGroupAssigned")}
            open={isNoDataGroupModalVisible}
            onCancel={handleClose}
            footer={[
                <SecondaryButton key="logout" onClick={logout}>
                    {t("button.logout")}
                </SecondaryButton>,
                <PrimaryButton name="assign_existing" key="assign" onClick={handleAssignExisting}>
                    {t("button.assignExisting")}
                </PrimaryButton>,
            ]}
        >
            <div data-name="no_data_group_selected_popup">
                <p>{t("modal.label.userIsNotAssigned", user)}</p>
                <p>{t("modal.label.notAuthorized")}</p>
            </div>
        </Modal>
    );
};
